// extracted by mini-css-extract-plugin
export default {"popupBackgroundWrapper":"style_popupBackgroundWrapper__pUIrw","popupContent":"style_popupContent__UoZ-I","mobile":"style_mobile__62tzT"};